import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationEditFolder.messages';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { createApiUrl, appSettings } from 'src/config';
import { requestAPIActions } from 'loopback-react-request';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';


export interface ConfigurationEditFolderProps {
  dispatch: any;
  drilledConfirm: (folderName: string) => void;
  drilledClose: () => void;
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
  isNested?: boolean;
  parentId?: string;
  folderId?: string;
  folderName?: string;
  metavalue?: string;
  groups: GlobalPrivateState['groups'];
  authenticator: GlobalPrivateState['authenticator'];
}

export interface ConfigurationEditFolderState {
  isOpen: boolean; 
  folderName: string; 
  metavalue: string;
}

export class ConfigurationEditFolderPartial extends React.Component<ConfigurationEditFolderProps, ConfigurationEditFolderState> {
  constructor(props: ConfigurationEditFolderProps) {
    super(props);
    this.state = {
      isOpen: false,
      folderName: this.props.folderName || '',
      metavalue: this.props.metavalue || '',
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {
    const { folderName, metavalue } = this.state;
    const { groups, folderId, isNested } = this.props;
    const currentFolder = folderId && groups && groups.result && groups.result.find(g => g.id === folderId);
    // Need to default populate folderName with currentFolder.name

    return (
      <Modal 
        isOpen={this.state.isOpen}
				backdrop={true}
				toggle={this.toggleModal}
        className="modal-dialog--small folder-create-modal"
      >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          <button onClick={this.toggleModal} className="close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
					<div>
						<h3 className="modal-heading">
              {currentFolder && currentFolder.parentId ? (
                <FormattedMessage {...MESSAGES.configurationEditFolderNestedHeading} />
              ) : (
                <FormattedMessage {...MESSAGES.configurationEditFolderHeading} />
              )}
            </h3>
						<div className="modal-body">
							<h4 className="modal-smheading"><FormattedMessage {...MESSAGES.configurationEditFolderName} /></h4>
              <input className="mb-3" type="text" value={folderName} onChange={(e) => this.setState({...this.state, folderName: e.target.value})} />

              <h4 className="modal-smheading">{!isNested ? <FormattedMessage {...MESSAGES.configurationEditBuildingNumber} /> : <FormattedMessage {...MESSAGES.configurationEditOpportunityNumber} />}</h4>
              <input type="text" value={metavalue} onChange={(e) => this.setState({...this.state, metavalue: e.target.value})} />
            </div>
						<div className="modal-actions text-center">
							<button 
								className="btn btn-light btn-bordered w-100"
								onClick={this.toggleModal}
                disabled={groups.updating}
							>
								<FormattedMessage {...MESSAGES.configurationEditFolderCancel} />
							</button>
							<button 
								className="btn btn-secondary w-100"
								onClick={this.handleEdit}
								disabled={groups.updating}
							>
								<FormattedMessage {...MESSAGES.configurationEditFolderConfirm} />
							</button>
						</div>
					</div>
        </div>
      </Modal>
    );
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.props.drilledClose(), 151);
  } 

  handleEdit = async (event: any) => {
    const { folderId } = this.props;
    const { folderName, metavalue } = this.state;

    if (!folderName || !folderId) { return; }

    if (this.props.drilledConfirm) { 
			this.props.drilledConfirm(folderName);
		}
    this.toggleModal();

		console.log('closed?');

    const values: any = {
      name: folderName,
      metavalue
    };

    const apiUrl = createApiUrl(appSettings.config);
    const accessToken = this.props.authenticator.accessToken && this.props.authenticator.accessToken.id;
    if (!accessToken) return;

    // Update the folder in the folder list...
    const foldersBefore = this.props.groups.result || [];
    const updatedFolders = foldersBefore.map(folder => 
      folder.id === folderId ? { ...folder, name: folderName, metavalue } : folder
    );
    this.props.dispatch(requestAPIActions.loadPlain('groups', updatedFolders));

    // Make the update request
    const response = await fetch(`${apiUrl}/Groups/${folderId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': accessToken,
      },
      body: JSON.stringify(values),
    });

    // Restore if the update fails
    if (!response.ok) {
      this.props.dispatch(requestAPIActions.loadPlain('groups', foldersBefore));
      // Optionally show a toaster popup warning
    }
  }
}

// export const UserListDeleteModal = connect((state: GlobalPrivateState) => ({
// }))(UserListDeleteModalPartial as any);

export const ConfigurationEditFolder = connect((state: GlobalPrivateState) => ({
  user: state.user,
  userData: state.userData,
  groups: state.groups,
  authenticator: state.authenticator
}))(ConfigurationEditFolderPartial);

export default ConfigurationEditFolder;